import { useState, useEffect } from "react";

// Alternative: Bouncy Checkbox with Spring Animation
const BouncyCheckbox = ({ checked, onChange, label, t }) => {
  const [spring, setSpring] = useState({ scale: 1, rotate: 0 });
  
  useEffect(() => {
    if (checked) {
      setSpring({ scale: 1.2, rotate: 0 });
      setTimeout(() => setSpring({ scale: 1, rotate: 0 }), 200);
    } else {
      setSpring({ scale: 1, rotate: 0 });
    }
  }, [checked]);
  
  return (
    <label className="flex items-center gap-3 cursor-pointer group">
      <div className="relative">
        <input
          type="checkbox"
          checked={checked}
          onChange={() => onChange(!checked)}
          className="sr-only"
        />
        <div
          className={`
            w-5 h-5 rounded-md border-2 transition-all duration-200 cursor-pointer
            flex items-center justify-center
            ${checked 
              ? 'bg-gradient-to-br from-[#B03982] to-[#733C86] border-[#B03982]' 
              : 'bg-white border-gray-300 group-hover:border-[#B03982]'
            }
          `}
          style={{
            transform: `scale(${spring.scale}) rotate(${spring.rotate}deg)`,
            transition: 'transform 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
          }}
        >
          {checked && (
            <svg
              className="w-3.5 h-3.5 text-white animate-check-bounce"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          )}
        </div>
      </div>
      
      <span className={`
        text-sm transition-all duration-300
        ${checked 
          ? 'text-[#B03982] font-medium' 
          : 'text-gray-600 group-hover:text-[#B03982]'
        }
        ${checked ? 'translate-x-0.5' : ''}
      `}>
        {label || t("remember_me")}
      </span>
    </label>
  );
};

export const CustomCheckbox = ({ checked, onChange, label, t, variant = "default" }) => {
  return <BouncyCheckbox checked={checked} onChange={onChange} label={label} t={t} />;
};